import { CLUSTER_ID_KEY, } from './experimentation.utils';
import { Experimenter } from './experimenter';
export class ExperimentationService {
    constructor() {
        this.clusterId = '';
        this.EXPERIMENTAION_OBJECT_MAP = {};
    }
    static getInstance() {
        if (!ExperimentationService.instance) {
            ExperimentationService.instance = new ExperimentationService();
        }
        return ExperimentationService.instance;
    }
    init(projectConfig) {
        this.EXPERIMENTAION_OBJECT_MAP = {};
        this.onExperimentActivateCB = projectConfig.onExperimentActivateCB;
        this.clusterId = projectConfig.clusterId;
        for (const config of projectConfig.configList) {
            if (!!config && config.enabled) {
                this.EXPERIMENTAION_OBJECT_MAP[config.project] = new Experimenter({ ...config, ...projectConfig });
            }
        }
    }
    getExperimenterForProject(project) {
        if (project in this.EXPERIMENTAION_OBJECT_MAP) {
            return this.EXPERIMENTAION_OBJECT_MAP[project];
        }
        return undefined;
    }
    onExperimentActivated(experimentName, property, eventData) {
        if (this.onExperimentActivateCB) {
            let data = {};
            if (eventData) {
                data = { ...eventData };
            }
            data[CLUSTER_ID_KEY] = this.clusterId;
            this.onExperimentActivateCB(experimentName, property, data);
        }
    }
}
export const getExperimentationVariableForType = (project, flagKey, variableKey, type) => {
    switch (type) {
        case 'string':
            return ExperimentationService.getInstance()
                .getExperimenterForProject(project)
                ?.getFeatureVariableString(flagKey, variableKey);
        case 'number':
            return ExperimentationService.getInstance()
                .getExperimenterForProject(project)
                ?.getFeatureVariableNumber(flagKey, variableKey);
        case 'boolean':
            return ExperimentationService.getInstance()
                .getExperimenterForProject(project)
                ?.getFeatureVariableBoolean(flagKey, variableKey);
        case 'json':
            return ExperimentationService.getInstance()
                .getExperimenterForProject(project)
                ?.getFeatureVariableJson(flagKey, variableKey);
        default:
            return undefined;
    }
};
//# sourceMappingURL=experimentation-service.js.map